import { DragSource } from 'react-dnd-compat';
import { dragTypes } from 'ContentEditorUI/lib/layouts/constants';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction
// @ts-ignore not typed
} from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { connect } from 'react-redux';
import BaseGridTableToolbar from './BaseGridTableToolbar';
import BaseHorizontalStackToolbar from './BaseHorizontalStackToolbar';
import BaseVerticalStackToolbar from './BaseVerticalStackToolbar';
const dragSource = {
  beginDrag(props) {
    const {
      toolbarInfo,
      draggingStartedAndDeselectExisting
    } = props;
    if (!toolbarInfo) {
      return;
    }
    const {
      id,
      parentId,
      layoutNodeType,
      isGridCell,
      gridLayoutId
    } = toolbarInfo;
    const dragItem = {
      parentId,
      isGridCell,
      layoutNodeType,
      dragId: id,
      dragParentId: parentId,
      dragType: dragTypes.EXISTING_ITEM,
      originLayoutSectionId: gridLayoutId,
      isGrid: layoutNodeType === 'GRID_LAYOUT_GRID',
      isRow: layoutNodeType === 'GRID_LAYOUT_HORIZONTAL_STACK',
      isColumn: layoutNodeType === 'GRID_LAYOUT_VERTICAL_STACK'
    };

    // @ts-ignore Grids TODO: hook this up with drag item type for grids toolbars
    draggingStartedAndDeselectExisting(dragItem);
    return dragItem;
  },
  canDrag(props) {
    return !props.isInNonDefaultBreakpointMode;
  },
  endDrag(props, monitor) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = props;
    draggingStoppedAndReselectIfNeeded(monitor.getItem(), monitor.didDrop());
  }
};
function dragCollect(monitor) {
  return {
    isDragging: monitor.isDragging()
  };
}
const mapStateToProps = state => ({
  isInNonDefaultBreakpointMode: !getIsInDefaultBreakpointMode(state)
});
const mapDispatchToProps = {
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction
};
export const GridTableToolbar = connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(BaseGridTableToolbar));
export const HorizontalStackToolbar = connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(BaseHorizontalStackToolbar));
export const VerticalStackToolbar = connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(BaseVerticalStackToolbar));